<template>
  <!-- Modal -->
  <div class="modal fade modal-fade-in-scale-up" :id="modalHtmlId" aria-hidden="false" aria-labelledby="modalHtmlId"
       role="dialog" tabindex="-1">
    <div class="modal-dialog modal-simple">
      <user-form
        :editable="editable"
        :modalHtmlId="modalHtmlId"
        :fullName="fullName"
        @submit="submit"
        @setFullName="setFullName"
        ref="form"/>
    </div>
  </div>
  <!-- End Modal -->
</template>

<script>
import UserForm from './UserForm'
import { http } from '@/http'

export default {
  name:       'edit-modal',
  components: {
    UserForm
  },
  data () {
    return {
      editable:    true,
      modalHtmlId: 'userEditModal',
      fullName:    '',
      modal:       undefined
    }
  },
  methods:    {
    submit (data) {

      if (data.Password === '') {
        delete data.Password
      }

      let id = data.id
      if (id) {
        delete data.id
      }

      http.put(
        `User/` + id,
        data
      )
        /* zpracovani pozadavku */
          .then(response => {

            let rowData = {
              id:  id,
              row: data
            }

            this.$emit('updateRow', rowData)
            $('#' + this.modalHtmlId).modal('hide')
          })

          .catch(e => {
            console.error(e)
          })
    },
    setFullName (data) {
      this.fullName = ''
      if (data.FirstName) {
        this.fullName = data.FirstName
      }

      if (data.LastName) {
        this.fullName += ' ' + data.LastName
      }
    },
    setDefaults (user) {
      // @TODO: hack jquery
      if (!this.modal) {
        this.modal = this.$refs.form
      }

      this.setFullName({ FirstName: user.FirstName, LastName: user.LastName })
      this.modal.setDefaults(user)
    }
  }
}
</script>
